import { Component } from '@angular/core';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-dialog-alterar-status-massa',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
  ],
  templateUrl: './dialog-alterar-status-massa.component.html',
  styleUrls: ['./dialog-alterar-status-massa.component.css'],
})
export class DialogAlterarStatusMassaComponent {
  selectedStatus: boolean | null = null;

  constructor(public dialogRef: MatDialogRef<DialogAlterarStatusMassaComponent>) {}

  cancelar(): void {
    this.dialogRef.close();
  }

  confirmar(): void {
    this.dialogRef.close(this.selectedStatus);
  }
}
